module.exports = __webpack_public_path__ + "img/2.969ad22d.jpg";